'use strict';
import util from '../util';



var initOrderReturn = function() {
	
    $(window).on('load orientationchange', function () {
        $('.ui-selectmenu-text').addClass('hide-text');
    });
	
    $('.return-qty').on('selectmenuchange change', onQtyChange);
    $('.productReturn button#return').on('click', onReturnSubmit);
	
    $('.returnreason').on('selectmenuchange change', function() {
        if($(this).find('.returnreason').val() != 'Select Reason') {
            $(this).parents().eq(2).find('.reason-error').hide();
        }
    });
    $('.return-qty, .returnreason').on('selectmenuchange change', function(){
        $(this).siblings('span').find('.ui-selectmenu-text').removeClass('hide-text');
    });
}

function onQtyChange() {
    var totalQty = calculateTotalQty(this);
    $('.returnQuantity').text(totalQty);
}

function calculateTotalQty(elem) {
    var totalQty = 0;
    $('.return-qty').each(function() {
        totalQty = totalQty + Number($(this).val());
    });
	
    if(totalQty > 0) {
        $('.return-button-error').hide();
    } else {
        $(elem).parents().eq(1).find('.reason-error').hide();
    }
	
    return totalQty;
}

function onReturnSubmit() {
    var totalQty = calculateTotalQty(); 
    var isError = false;
	
    if(totalQty == 0) {
        $('.return-button-error').show();
        isError = true;

        //To throw error when qty is not selected by reason is selected
        $('.ordered-items .item-detail-row').each(function() {
            if($(this).find('.returnreason').val() != 'Select Reason') {
                if($(this).find('.return-qty').val() == 0) {
                    $(this).find('.generic-error').show();
                    $(this).find('.item-qty-error').show();
                    $(this).find('.reason-error').hide();
                }
            } else {
                $(this).find('.generic-error').show();
                $(this).find('.item-qty-error').show();
                $(this).find('.reason-error').show();
            }
        });
    } else {
		
        $('.ordered-items .item-detail-row').each(function() {
            if($(this).find('.return-qty').val() > 0) {
                if($(this).find('.returnreason').val() == 'Select Reason') {
                    $('.return-button-error').show();
                    $(this).find('.generic-error').show();
                    $(this).find('.item-qty-error').hide();
                    $(this).find('.reason-error').show();
                    isError = true;
                }
            } else if ($(this).find('.return-qty').val() == 0) {
                if($(this).find('.returnreason').val() == 'Select Reason') {
                    $('.return-button-error').show();
                    $(this).find('.generic-error').show();
                    $(this).find('.item-qty-error').show();
                    $(this).find('.reason-error').show();
                }
            }
			
            if($(this).find('.returnreason').val() != 'Select Reason') {
                if($(this).find('.return-qty').val() == 0) {
                    $('.return-button-error').show();
                    $(this).find('.generic-error').show();
                    $(this).find('.item-qty-error').show();
                    $(this).find('.reason-error').hide();
                    isError = true;
                }
            }
        });
    }
	
    var commentMessage = $('textarea[name*="returnComments"]').val();
    if(commentMessage != '') {
        if (!util.validateMessage(commentMessage)) {
            $('.commentserror').show();
            isError = true;
        } else {
            $('.commentserror').hide();
        }
    }
	
    if(isError) {
        return false;
    }
	
	
}

export default {
    init: function () {
        initOrderReturn();
    }
};